// 折线图
<template>
  <div v-if="seriesData.length" ref="chart" class="chart printItem"></div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name:'LineChart',
  components: {},
  props: {
    chartType: {
      type: String,
      default: () => '',
    },
    taskItemData: {
      type: Object,
      default: () => {},
    },
    exportChartList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      seriesData: [],
      xAxisData: [],
    };
  },
  watch: {
    taskItemData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.seriesData = Array.isArray(this.taskItemData.surveyItems)
          ? this.taskItemData.surveyItems.map(({ text, staffNum }) => ({
              name: text,
              value: staffNum,
            }))
          : [];
        this.xAxisData = Array.isArray(this.taskItemData.surveyItems)
          ? this.taskItemData.surveyItems.map(({ text, staffNum }) => text)
          : [];
        this.$nextTick(() => {
          if (this.seriesData.length) this.initChart();
        });
      },
    },
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    initChart() {
      let chartDom = this.$refs.chart;
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['#3aa1ff', '#36cbcb', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
        tooltip: {
          trigger: 'axis',
        },
        grid:{
          top:'10',
          bottom:'80'
        },
        xAxis: {
          type: 'category',
          data: this.xAxisData,
          axisLabel: {
            fontSize:12,
            show: true,
            interval: 0,
            width: 100,
            rotate: 90,
            formatter: (value, index) => {
              if (value.length >= 6) {
                return value.substr(0, 5) + '...';
              } else {
                return value;
              }
            },
          },
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            type: 'line',
            data: this.seriesData,
          },
        ],
      };

      option && myChart.setOption(option);
      this.exportChartList[this.chartType] = myChart;
    },
  },
};
</script>

<style lang="less" scoped>
.chart {
  width: 625px;
  height: 400px;
  margin: 0 auto;
}
</style>
